export default {
  PAYABLES_TABLE_STATE_SET: 'PAYABLES/TABLE_STATE_SET',
  PAYABLES_TABLE_STATE_RESET: 'PAYABLES/TABLE_STATE_RESET',
};
